import { datadogRum } from "@datadog/browser-rum";
import { isAxiosError } from "axios";
import { ErrorMessageWithActions } from "PFComponents/error_message";
import { removeLoadingState } from "PFCore/initializers/remove_loading_state";
import { ErrorInfo, PropsWithChildren } from "react";
import { ErrorBoundary, FallbackProps } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { useMount } from "react-use";

const DisplayServerError = () => {
  const { t } = useTranslation();

  useMount(() => {
    removeLoadingState();
  });

  return <p>{t("internalServerError")}</p>;
};

const DisplayGenericError = () => {
  useMount(() => {
    removeLoadingState();
  });
  return <ErrorMessageWithActions />;
};

// Must never throw: an error thrown from a fallback escapes this boundary,
// which can cause a render loop or leave the loader on screen.
const FallbackComponent = ({ error }: FallbackProps) => {
  if (!isAxiosError(error)) {
    return <DisplayGenericError />;
  }

  if (error.response?.status === 404) {
    window.location.replace("https://profinda.com");
    return null;
  }

  return <DisplayServerError />;
};

export const CurrentAccountErrorBoundary = ({ children }: PropsWithChildren) => {
  const handleError = (error: Error, errorInfo: ErrorInfo) => {
    if (datadogRum) {
      datadogRum.addError(error, errorInfo);
    }
  };

  return (
    <ErrorBoundary onError={handleError} FallbackComponent={FallbackComponent}>
      {children}
    </ErrorBoundary>
  );
};
